(function () {
  'use strict';

  var selector = '[data-ailana-slider]';

  function getSliders(root) {
    var sliders = [];

    if (root.matches && root.matches(selector)) {
      sliders.push(root);
    }

    if (root.querySelectorAll) {
      sliders = sliders.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    }

    return sliders;
  }

  function initialise(slider) {
    if (slider.getAttribute('data-ailana-slider-ready') === 'true') {
      return;
    }

    var track = slider.querySelector('[data-ailana-slider-track]');
    var previous = slider.querySelector('[data-ailana-slider-prev]');
    var next = slider.querySelector('[data-ailana-slider-next]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-ailana-slide]')) : [];
    var firstSlide = slides[0];
    var delay = parseInt(slider.getAttribute('data-ailana-slider-autoplay'), 10) || 0;
    var reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var looping = slides.length > 1;
    var clones = [];
    var touching = false;
    var timer = null;
    var settleTimer = null;
    var currentStep = 0;

    if (!track || !previous || !next || !firstSlide) {
      return;
    }

    function cloneSlide(slide) {
      var clone = slide.cloneNode(true);
      var identified = clone.querySelectorAll('[id]');
      var focusable = clone.querySelectorAll('a, button, input, select, textarea, [tabindex]');

      clone.removeAttribute('data-ailana-slide');
      clone.setAttribute('data-ailana-slider-clone', '');
      clone.setAttribute('aria-hidden', 'true');

      Array.prototype.forEach.call(identified, function (element) {
        element.removeAttribute('id');
      });

      Array.prototype.forEach.call(focusable, function (element) {
        element.setAttribute('tabindex', '-1');
      });

      return clone;
    }

    if (looping) {
      clones.push(cloneSlide(slides[slides.length - 1]));
      track.insertBefore(clones[0], slides[0]);

      clones.push(cloneSlide(slides[0]));
      clones.push(cloneSlide(slides[1]));
      track.appendChild(clones[1]);
      track.appendChild(clones[2]);
    }

    slider.setAttribute('data-ailana-slider-ready', 'true');

    function maximum() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function step() {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;

      return firstSlide.getBoundingClientRect().width + gap;
    }

    function scrollToPosition(left, smooth) {
      var behaviour = smooth && !(reducedMotion && reducedMotion.matches) ? 'smooth' : 'auto';

      if (typeof track.scrollTo === 'function') {
        try {
          track.scrollTo({ left: left, behavior: behaviour });
          return;
        } catch (error) {
          track.scrollLeft = left;
          return;
        }
      }

      track.scrollLeft = left;
    }

    function updateControls() {
      var limit = maximum();

      if (looping) {
        previous.disabled = limit <= 2;
        next.disabled = limit <= 2;
        return;
      }

      previous.disabled = track.scrollLeft <= 2;
      next.disabled = limit <= 2 || track.scrollLeft >= limit - 2;
    }

    function normaliseLoop() {
      var unit;
      var index;

      if (!looping) {
        return;
      }

      unit = step();
      currentStep = unit;
      index = Math.round(track.scrollLeft / unit);

      if (index <= 0) {
        scrollToPosition(unit * slides.length, false);
      } else if (index > slides.length) {
        scrollToPosition(unit * (index - slides.length), false);
      }

      updateControls();
    }

    function scheduleNormalise() {
      if (!looping) {
        return;
      }

      if (settleTimer !== null) {
        window.clearTimeout(settleTimer);
      }

      settleTimer = window.setTimeout(normaliseLoop, 180);
    }

    function move(direction) {
      var left = track.scrollLeft + (step() * direction);

      if (looping) {
        scrollToPosition(left, true);
      } else {
        scrollToPosition(Math.max(0, Math.min(maximum(), left)), true);
      }
    }

    function autoplay() {
      if (document.hidden || touching || (reducedMotion && reducedMotion.matches) ||
          slider.matches(':hover') || slider.contains(document.activeElement)) {
        return;
      }

      if (maximum() > 2) {
        move(1);
      }
    }

    function startTouch() {
      touching = true;
    }

    function endTouch() {
      touching = false;
      scheduleNormalise();
    }

    function handleScroll() {
      updateControls();

      if (!touching) {
        scheduleNormalise();
      }
    }

    function handleResize() {
      var oldStep = currentStep || step();
      var index = Math.round(track.scrollLeft / oldStep);

      currentStep = step();

      if (looping) {
        scrollToPosition(currentStep * index, false);
        normaliseLoop();
      }

      updateControls();
    }

    function movePrevious() {
      move(-1);
    }

    function moveNext() {
      move(1);
    }

    previous.addEventListener('click', movePrevious);
    next.addEventListener('click', moveNext);
    track.addEventListener('scroll', handleScroll, { passive: true });
    track.addEventListener('touchstart', startTouch, { passive: true });
    track.addEventListener('touchend', endTouch, { passive: true });
    track.addEventListener('touchcancel', endTouch, { passive: true });
    window.addEventListener('resize', handleResize);

    currentStep = step();

    if (looping) {
      scrollToPosition(currentStep, false);
    }

    if (delay > 0) {
      timer = window.setInterval(autoplay, delay);
    }

    slider.ailanaLaunchDestroy = function () {
      if (timer !== null) {
        window.clearInterval(timer);
      }

      if (settleTimer !== null) {
        window.clearTimeout(settleTimer);
      }

      previous.removeEventListener('click', movePrevious);
      next.removeEventListener('click', moveNext);
      track.removeEventListener('scroll', handleScroll);
      track.removeEventListener('touchstart', startTouch);
      track.removeEventListener('touchend', endTouch);
      track.removeEventListener('touchcancel', endTouch);
      window.removeEventListener('resize', handleResize);

      clones.forEach(function (clone) {
        if (clone.parentNode === track) {
          track.removeChild(clone);
        }
      });

      slider.removeAttribute('data-ailana-slider-ready');
      slider.ailanaLaunchDestroy = null;
    };

    updateControls();
  }

  function initialiseAll(root) {
    getSliders(root).forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    getSliders(event.target).forEach(function (slider) {
      if (typeof slider.ailanaLaunchDestroy === 'function') {
        slider.ailanaLaunchDestroy();
      }
    });
  });
}());
